import { API_URL, OAUTH_APP_REDIRECT } from '../config/apiConfig';
import { Capacitor } from '@capacitor/core';
import { POST_LOGIN_VIDEO_PATH } from '../PostLoginVideo';

export function isCapacitorNative() {
  try {
    return Capacitor.isNativePlatform() === true;
  } catch {
    return false;
  }
}

export function buildCapacitorGoogleAuthUrl() {
  const appRedirect = encodeURIComponent(OAUTH_APP_REDIRECT);
  return `${API_URL}/auth/google?app_redirect=${appRedirect}`;
}

/** Web browser or legacy file:// without Electron preload (electron_redirect). */
export function buildWebOrFileGoogleAuthUrl() {
  const base = `${API_URL}/auth/google`;
  const isFileProtocol = typeof window !== 'undefined' && window.location.protocol === 'file:';
  if (isFileProtocol) {
    return `${base}?electron_redirect=${encodeURIComponent(window.location.href)}`;
  }
  return base;
}

/**
 * Handle com.coda.game://auth/callback?token=... after Google OAuth (Capacitor).
 * @returns {boolean} true if URL was an OAuth callback and was applied
 */
export function applyOAuthDeepLink(urlString, { setUser, navigate }) {
  let u;
  try {
    u = new URL(urlString);
  } catch {
    return false;
  }
  if (u.protocol !== 'com.coda.game:') {
    return false;
  }
  if (u.hostname !== 'auth') {
    return false;
  }
  if (!u.pathname.includes('callback')) {
    return false;
  }
  const token = u.searchParams.get('token');
  const refreshToken = u.searchParams.get('refreshToken');
  const userId = u.searchParams.get('userId');
  const username = u.searchParams.get('username');
  if (!token || !userId || !username) {
    return false;
  }
  const name = decodeURIComponent(username);
  localStorage.setItem('token', token);
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  } else {
    localStorage.removeItem('refreshToken');
  }
  localStorage.setItem('user', name);
  localStorage.setItem('userId', userId);
  setUser({ username: name, userId: parseInt(userId, 10) });
  navigate(POST_LOGIN_VIDEO_PATH, { replace: true });
  return true;
}
